import React from 'react';
import { withTheme } from 'styled-components';
import PropTypes from 'prop-types';
import { useSSRQuery, useLazySSRQuery } from '../../graphql';
import INITIAL_DATA_QUERY from './wrappedStadiumFlightSearchForm/initialData.query.graphql';
import NEARBY_FLIGHT_LOCATIONS_QUERY from './wrappedStadiumFlightSearchForm/nearbyFlightLocations.query.graphql';
import FLIGHT_MARKET_QUERY from './wrappedStadiumFlightSearchForm/flightMarket.query.graphql';
import RaidersFlightSearchForm from '@g4/next-furniture/FlightSearchForm/raidersFlightSearchForm';

const WrappedStadiumFlightSearchForm = props => {
  const initialDataResponse = useSSRQuery(INITIAL_DATA_QUERY);

  const [fetchNearbyLocations, nearbyLocationsResponse] = useLazySSRQuery(
    NEARBY_FLIGHT_LOCATIONS_QUERY
  );

  const [fetchMarket, marketResponse] = useLazySSRQuery(FLIGHT_MARKET_QUERY);

  React.useEffect(() => {
    const shouldUpdateErrorDisplay = () => {
      const shouldDisplayErrorBanner =
        marketResponse.called &&
        !marketResponse.loading &&
        marketResponse.data.flightMarket.calendar === null;
      props.setIsFlightMarketError(shouldDisplayErrorBanner);
    };
    shouldUpdateErrorDisplay();
  }, [marketResponse, props]);

  if (initialDataResponse.loading) {
    return null;
  }

  const errors = [
    initialDataResponse.error,
    marketResponse.error,
    nearbyLocationsResponse.error,
  ].filter(Boolean);

  if (errors.length) {
    // Give our custom error a human-readable message
    const error = new Error(
      `Failed to query flight search form data: ${errors.join(', ')}`
    );

    // Add each GraphQL error to the new custom error
    error.apiErrors = errors;

    throw error;
  }

  const initialValues = {
    tripType: 'ROUNDTRIP',
    destination: 'LAS',
    withHotel: true,
  };

  const {
    flightSearchForm,
    stadiumPackages,
  } = initialDataResponse?.data?.application?.translations;

  const translations = {
    ...flightSearchForm,
    ...stadiumPackages,
  };

  const configurations = initialDataResponse.data.application.configurations;
  const locations = initialDataResponse.data.flightLocations;
  return (
    <>
      <RaidersFlightSearchForm
        translations={translations}
        configurations={configurations}
        locations={locations}
        fetchNearbyLocations={fetchNearbyLocations}
        nearbyLocationsLoading={nearbyLocationsResponse.loading}
        nearbyLocations={
          nearbyLocationsResponse.data
            ? nearbyLocationsResponse.data.flightLocations
            : []
        }
        fetchMarket={fetchMarket}
        marketLoading={marketResponse.loading}
        market={marketResponse.data}
        initialValues={initialValues}
        {...props}
      />
    </>
  );
};

WrappedStadiumFlightSearchForm.propTypes = {
  setIsFlightMarketError: PropTypes.func,
};

export default withTheme(WrappedStadiumFlightSearchForm);
